import React, { Component } from 'react';

import Select from 'react-select';


import lowest from "../../assets/priority/lowest.svg";
import medium from "../../assets/priority/medium.svg";
import highest from "../../assets/priority/highest.svg";
import './styles.scss';

export default class PrioritySelect extends Component {

    constructor(props){
        super(props);
        let priorityOptions = [
            {
                value: 'high',
                label: <div className={'priority-option'}>
                    <img src={highest} alt={'alta'} />
                    <div>Alta</div>
                </div>
            },
            {
                value: 'medium',
                label: <div className={'priority-option'}>
                    <img src={medium} alt={'media'} />
                    <div>Media</div>
                </div>
            },
            {
                value: 'low',
                label: <div className={'priority-option'}>
                    <img src={lowest} alt={'baja'} />
                    <div>Baja</div>
                </div>
            }
        ];

        this.state = {
            priorityOptions
        };
    }

    _handleChange = (values) => {
        this.props.changeAction(values.value);
    };

    render() {

        let {priority} = this.props;
        let priorityValue = false;
        let priorityOption = this.state.priorityOptions.find(p => p.value === priority);
        if(priorityOption) priorityValue = priorityOption;

        return (
            <Select className={"priority-select"} classNamePrefix={"pty-select"}
                    isSearchable={false} placeholder={"Seleccione una"}
                    value={priorityValue}
                    onChange={this._handleChange}
                    options={this.state.priorityOptions} />
        );
    }
}

PrioritySelect.defaultProps = {
    priority: false,
    changeAction: () => {}
};



// WEBPACK FOOTER //
// ./src/components/prioritySelect/PrioritySelect.js